<template>
  <FooterLinks />
  <SlideLogin />
  <SlideSignUp />
  <StoreRedirect v-if="!window.Cypress" />
  <SlideSignUpTimed />

  <footer class="site-footer">
    <div class="container">
      <nav class="helpful-links">
        <ul class="helpful-link-group helpful-link-group--left">
          <li
            v-for="link in footerLeftLinks"
            :key="link.url"
            class="helpful-link-group__item"
          >
            <a :href="link.url">
              {{ link.title }}
            </a>
          </li>
        </ul>

        <ul class="helpful-link-group helpful-link-group--right">
          <li
            v-for="link in footerRightLinks"
            :key="link.url"
            class="helpful-link-group__item"
          >
            <a :href="link.url">
              {{ link.title }}
            </a>
          </li>
        </ul>

        <ul class="helpful-link-group helpful-link-group--logo">
          <li class="helpful-link-group__item">
            <a href="/">
              <img
                class="site-footer__logo"
                src="https://cdn.shopify.com/s/files/1/0942/9062/files/monogram.svg?v=1652005246"
                width="82"
                height="66"
              />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
import FooterLinks from "@/components/FooterLinks.vue";
import { defineAsyncComponent } from "vue";
const SlideLogin = defineAsyncComponent(() =>
  import(/* webpackChunkName: "SlideLogin" */ "@/components/SlideLogin.vue")
);
const SlideSignUp = defineAsyncComponent(() =>
  import(/* webpackChunkName: "SlideSignUp" */ "@/components/SlideSignUp.vue")
);
const StoreRedirect = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "StoreRedirect" */ "@/components/StoreRedirect.vue"
  )
);
const SlideSignUpTimed = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "SlideSignUpTimed" */ "@/components/SlideSignUpTimed.vue"
  )
);

import { mapState } from "vuex";

export default {
  name: "FooterComponent",
  components: {
    FooterLinks,
    SlideLogin,
    SlideSignUp,
    StoreRedirect,
    SlideSignUpTimed,
  },
  computed: {
    ...mapState("app", ["footerLeftLinks", "footerRightLinks"]),
  },
};
</script>

<style lang="scss" scoped>
.site-footer {
  background-color: $color-white;
  padding: 40px 0;

  &__logo {
    width: 82px;

    @include respond-above(md) {
      width: 100px;
    }
  }
}
.helpful-links {
  display: flex;
  flex-direction: column;

  @include respond-above(md) {
    flex-direction: row;
  }
}

.helpful-link-group {
  display: flex;
  justify-content: center;
  font-size: 9px;

  &--left {
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    justify-content: center;

    order: 2;

    @include respond-above(md) {
      justify-content: left;
      order: 1;
    }
  }

  &--right {
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    justify-content: center;
    order: 3;
    @include respond-above(md) {
      justify-content: right;
    }
  }

  &--logo {
    order: 1;

    @include respond-above(md) {
      order: 2;
    }
  }

  &__item {
    padding: 12px 7px;
    text-transform: uppercase;

    a {
      color: $color-dark;
      font-weight: 600;
      text-decoration: none;
      letter-spacing: 0.55px;
    }
  }
}
</style>
